import type { GanttIndicator } from "@/modules/carga-trabalho";

import type { IndicadoresDialogProps } from "./types-indicadores-dialog";
import { useIndicadoresDialog } from "./use-indicadores-dialog";
import { IndicadoresDialogView } from "./view-indicadores-dialog";

/** Modal "Exibir indicadores no Gantt" das três perspectivas: o `GanttIndicatorsDialog` do DS sobre as `opcoes` que a perspectiva oferece. */
export function IndicadoresDialog<K extends GanttIndicator>(props: IndicadoresDialogProps<K>) {
  const vm = useIndicadoresDialog(props);

  return <IndicadoresDialogView {...vm} />;
}

export type * from "./types-indicadores-dialog";
